<!-- Navigation -->
<calsoft-vertical-navigation class="theme-dark"
                          [appearance]="'classic'"
                          [mode]="isScreenSmall ? 'over' : 'side'"
                          [name]="'mainNavigation'"
                          [navigation]="data.navigation.default[0]"
                          [opened]="!isScreenSmall">

    <div calsoftVerticalNavigationContentHeader>

        <!-- Actions -->
        <div class="actions">

            <div fxFlex="100" class="logo" >
                <div fxFlex="100" fxLayoutAlign="center center">
                    <img fxFlex="40"   style="margin-right: 50px;margin-top: 5px;"   src="assets/images/logo/2.png">
            
                </div>
            </div>
            
            
        </div>

      
     
    </div>

    <div calsoftVerticalNavigationContentFooter>
        <div class="logo">
            <img src="assets/images/logo/logo-text-on-dark.svg">
        </div>
    </div>

</calsoft-vertical-navigation>

<!-- Wrapper -->
<div class="wrapper">

    <!-- Header -->
    <div class="header">

        <!-- Navigation toggle button -->
        <button [attr.guide]="'classy-btn-1' + '__' + sanitizeUrl(url)" class="navigation-toggle-button buttonie" mat-icon-button
         (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'menu'"></mat-icon>
        </button>
       
          <div  fxFlex="100" *ngIf="opened" fxLayoutAlign="space-around center" >
            <mat-icon >search</mat-icon>
            &nbsp;
            <input [attr.guide]="'classy-inp-2' + '__' + sanitizeUrl(url)" class="w-full h-full"     
                [formControl]="searchControl"
                [matAutocomplete]="matAutocomplete"
                [placeholder]="'Search...'"
                (keydown)="onKeydown($event)"
                />
            <mat-autocomplete
                class="max-h-128 sm:px-2 border-t rounded-b shadow-md"
                [autoSelectActiveOption]="true"
                [disableRipple]="true"
                #matAutocomplete="matAutocomplete">
                <mat-option
                    class="py-0 px-6 text-md pointer-events-none text-secondary bg-transparent"
                    *ngIf="resultSets && !resultSets.length">
                    No results found!
                </mat-option>
                <ng-container *ngFor="let resultSet of resultSets; trackBy:
                 trackByFn">
                    <mat-optgroup class="flex items-center mt-2 px-2">
                        <span class="text-sm font-semibold tracking-wider 
                        text-secondary">
                            {{resultSet.label.toUpperCase()}}</span>
                    </mat-optgroup>
                    <ng-container *ngFor="let result of resultSet.results; trackBy:
                     trackByFn">
                        <mat-option
                            class="group relative mb-1 py-0 px-6 text-md 
                            rounded-md hover:bg-gray-100 dark:hover:bg-hover"
                        
                            [value]="result.value"
                            (onSelectionChange)="$event.isUserInput && getToRoute(result.link)">

                           
                            <ng-container *ngIf="resultSet.id === 'contacts'">
                                <ng-container *ngTemplateOutlet="contactResult; context: {$implicit: result}"></ng-container>
                            </ng-container>
                         
                            <ng-container *ngIf="resultSet.id === 'pages'">
                                <ng-container *ngTemplateOutlet="pageResult; context: {$implicit: result}"></ng-container>
                            </ng-container>
                           
                            <ng-container *ngIf="resultSet.id === 'tasks'">
                                <ng-container *ngTemplateOutlet="taskResult; context: {$implicit: result}"></ng-container>
                            </ng-container>
                        </mat-option>
                    </ng-container>
                </ng-container>
            </mat-autocomplete>
            <button [attr.guide]="'classy-btn-3' + '__' + sanitizeUrl(url)" fxLayoutAlign="center center"
                class="buttonie"
                mat-icon-button
                (click)="close()">
                <mat-icon>close</mat-icon>
            </button>
          </div>

          <ng-template
#contactResult
let-result>
<div class="flex items-center">
    <div class="flex shrink-0 items-center 
    justify-center w-8 h-8 rounded-full overflow-hidden bg-primary-100 dark:bg-primary-800">
        <img
            *ngIf="result.avatar"
            [src]="result.avatar">
            <mat-icon >search</mat-icon>
    </div>
    <div class="ml-3 truncate">
        <span [innerHTML]="result.name"></span>
    </div>
</div>
</ng-template>

<!-- Page result template -->
<ng-template
#pageResult
let-result>
<div (click)="getToRoute(result.link)" class="flex flex-col">
    <div
        class="truncate leading-normal"
        [innerHTML]="result.defaultName || result.title"></div>
    <div class="truncate leading-normal text-sm text-secondary">
        {{result.link}}
    </div>
</div>
</ng-template>

<!-- Task result template -->
<ng-template
#taskResult
let-result>
<div class="flex items-center">
    <ng-container *ngIf="result.completed">
        <mat-icon
            class="mr-0 text-primary dark:text-primary-400"
            >add</mat-icon>
    </ng-container>
    <ng-container *ngIf="!result.completed">
        <mat-icon
            class="mr-0 text-hint"
            [svgIcon]="'heroicons_outline:check-circle'"></mat-icon>
    </ng-container>
    <div
        class="ml-3 truncate leading-normal"
        [ngClass]="{'line-through text-hint': result.completed}"
        [innerHTML]="result.title"></div>
</div>
</ng-template>

     
        <!-- Spacer -->
        <div class="spacer"></div>
        <button [attr.guide]="'classy-btn-4' + '__' + sanitizeUrl(url)" *ngIf="!opened" class="buttonie"
        (click)="open()" mat-flat-button >
          <mat-icon >search</mat-icon>
      </button>   
        <user></user>
    </div>

    <!-- Content -->
    <div class="content">

        <!-- *ngIf="true" hack is required here for router-outlet to work correctly. Otherwise,
             it won't register the changes on the layout and won't update the view. -->
        <router-outlet *ngIf="true"></router-outlet>

    </div>

</div>
